"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactstrap = require("reactstrap");
var _Notification = require("../Notification/Notification");
var _SourceForm = require("./SourceForm.styled");
var ErrorNotification = function ErrorNotification(_ref) {
  var message = _ref.message,
    link = _ref.link,
    onClose = _ref.onClose;
  return /*#__PURE__*/_react["default"].createElement(_reactstrap.Row, null, /*#__PURE__*/_react["default"].createElement(_SourceForm.StyledNotificationCol, null, /*#__PURE__*/_react["default"].createElement(_Notification.Notification, {
    type: "warning",
    linkMessage: link ? 'Learn more' : null,
    message: message,
    onCloseCallback: onClose,
    onClick: function onClick(e) {
      e.preventDefault();
      window.open(link, '_blank');
    }
  })));
};
ErrorNotification.propTypes = {
  message: _propTypes["default"].string,
  link: _propTypes["default"].string,
  onClose: _propTypes["default"].func
};
var _default = exports["default"] = ErrorNotification;